import {h, Fragment} from "preact"
import {CheckboxTile} from "./elements"

export default function FacetTileItem({facet, toggleProductFilter}) {
    return (
        <div class="ns-facet-tile-item" role="menu">
            {facet.data?.map(value => (
                <CheckboxTile
                    value={value.value}
                    selected={value.selected}
                    onChange={e => {
                        e.preventDefault()
                        toggleProductFilter(facet.field, value.value, !value.selected)
                    }}
                />
            ))}
        </div>
    )
}